import React from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Link,
} from '@mui/material';

import { Message } from '../../store/models/message.model';
import { DealType } from '../../store/types/types';
import { StyledContainer, StyledCell, Title } from './request-grid.styles';


const RequestGrid = ({ messageBody, programmatic }: Message & DealType) => {
  const {
    vendor,
    vertical,
    placingId,
    id,
    vastURL,
    orderDealType,
    adServerData,
    deactivationItems,
    industry,
    advertiser,
    advertiserID,
    globalIndustry,
    globalAdvertiser,
    globalAdvertiserID,
    creativeName,
    ae,
    dsp,
  } = { ...messageBody };

  let creativeIds = deactivationItems ? Object.keys(deactivationItems) : [];

  return (
    <StyledContainer>
      <Title variant="h6">Deactivation Request Attributes</Title>
      {
        programmatic ? (
          <Table>
            <TableBody>
              <TableRow>
                <StyledCell>FreeWheel Programmatic Ad ID</StyledCell>
                <TableCell component="th">
                {
                  adServerData.map((data) => { 
                    return data.adServerId
                  })
                }
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>FreeWheel Programmatic Deal ID(s)</StyledCell>
                <TableCell>
                  {
                    adServerData.map((data) => {
                      if (data.instanceIds) {
                        return data.instanceIds.map((instanceId) => {
                          return instanceId
                        })
                      } else {
                        return ""
                      }
                    })
                  }
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Vast URL</StyledCell>
                <TableCell component="th">
                  <Link href={vastURL} underline="hover">Link to Vast</Link>
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Global Industry</StyledCell>
                <TableCell component="th">{globalIndustry}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Global Advertiser ID</StyledCell>
                <TableCell component="th">{globalAdvertiserID}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Global Advertiser</StyledCell>
                <TableCell component="th">{globalAdvertiser}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>TACT Vertical</StyledCell>
                <TableCell component="th">{vertical}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Order Deal Type</StyledCell>
                <TableCell component="th">{orderDealType}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Creative Name</StyledCell>
                <TableCell component="th">{creativeName}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Placing ID</StyledCell>
                <TableCell component="th">{id}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Vendor</StyledCell>
                <TableCell component="th">{vendor}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>DSP</StyledCell>
                <TableCell component="th">{dsp}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>AE</StyledCell>
                <TableCell component="th">{ae}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : (
          <Table>
            <TableBody>
              <TableRow>
                <StyledCell>FreeWheel Creative ID(s)</StyledCell>
                <TableCell component="th">
                {
                  creativeIds.map((creativeId) => {
                    return creativeId
                  })
                }
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>FreeWheel Placement ID(s)</StyledCell>
                <TableCell component="th">
                {
                  creativeIds.map((key) => {
                    return deactivationItems[key].map((placement) => {
                      return placement.id
                    })
                  })
                }
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Vast URL</StyledCell>
                <TableCell component="th">
                  <Link href={vastURL} underline="hover">Link to Vast</Link>  
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Industry</StyledCell>
                <TableCell component="th">{industry}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Advertiser ID</StyledCell>
                <TableCell component="th">{advertiserID}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Advertiser</StyledCell>
                <TableCell component="th">{advertiser}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>TACT Vertical</StyledCell>
                <TableCell component="th">{vertical}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Order Deal Type</StyledCell>
                <TableCell component="th">{orderDealType}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Creative Name</StyledCell>
                <TableCell component="th">{creativeName}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Placing ID</StyledCell>
                <TableCell component="th">{placingId}</TableCell>
              </TableRow>
              <TableRow>
                <StyledCell>Vendor</StyledCell>
                <TableCell component="th">{vendor}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )
      }
    </StyledContainer>
  )
};

export default RequestGrid;